import { iAlarm } from "@/services";

import store from "@/store/index";
import router from "@/router";
import Util from "@/common/util";
import CONSTANTS from "@/common/constants";

const state = {
  badgeCount: 0,
  toggle: false,
  alarmNew: false,
  timeout: null,
};

const mutations = {
  setToggleState: (state, toggle) => {
    state.toggle = toggle;
  },
};

const actions = {
  // 공지사항 호출
  async startAnnouncement({ dispatch }) {
    dispatch("getAnnouncement");
  },
  // 알림 timeout 시작
  async startAlarmCount({ dispatch }) {
    dispatch("getAlarmCount");
    dispatch("alarmCount");
  },
  async alarmCount({ state, dispatch }) {
    state.timeout = setTimeout(() => {
      dispatch("getAlarmCount");
      dispatch("alarmCount");
    }, 10000);
  },

  // 알림 timeout 종료
  async stopAlarmCount({ state }) {
    clearTimeout(state.timeout);
  },
  async getAnnouncement({ dispatch }) {
    try {
      const res = await iAlarm.getAnnouncement();
      if (!res || !res.data) {
        console.error("공지사항 응답이 없습니다.");
        return;
      }

      console.log("공지사항 응답:", res);

      // 로그아웃 검사
      let errMsg = "";
      if (res.data.code === "TK0001") {
        errMsg = "로그아웃 되었습니다.";
      } else if (res.data.code === "TK0003") {
        errMsg = "중복 로그인으로 인해\n자동으로 로그아웃 되었습니다.";
      }

      if (errMsg) {
        // 로그아웃 처리 로직
        dispatch("stopAlarmCount");
        store.dispatch("auth/clearAuth");

        store.commit("common/openGlobalModal", {
          content: errMsg,
          icon: "warn",
        });

        router.push("/login");
        return;
      }

      return res;
    } catch (error) {
      console.error("공지사항 조회 중 오류 발생:", error);
      return;
    }
  },
  // 알림 status 가져오기
  async getAlarmCount({ dispatch }) {
    const data = Util.getToken(CONSTANTS.TOKEN.USER_DATA);

    if (!data) {
      dispatch("stopAlarmCount");
      store.dispatch("auth/clearAuth");

      return;
    }

    const res = await iAlarm.getAlarmCount();

    // 로그아웃 검사
    let errMsg = "";
    if (res.data.code === "TK0001") {
      errMsg = "로그아웃 되었습니다.";
    } else if (res.data.code === "TK0003") {
      errMsg = "중복 로그인으로 인해\n자동으로 로그아웃 되었습니다.";
    }

    if (errMsg) {
      // 로그아웃
      dispatch("stopAlarmCount");
      store.dispatch("auth/clearAuth");

      store.commit("common/openGlobalModal", {
        content: errMsg,
        icon: "warn",
      });

      router.push("/login");

      return;
    }

    // 새로운 알림 설정
    if (res.data.badgeCount > 0) {
      state.alarmNew = true;
    } else {
      state.alarmNew = false;
    }

    state.badgeCount = res.data.badgeCount;

    return res.data;
  },

  async setAlarmReadOne({ dispatch }, payload) {
    const res = await iAlarm.readAlarmOne({ alarmId: payload.alarmId });
    if (!res.code) {
      dispatch("getAlarmCount");
    }
  },

  async setAlarmUnReadOne({ dispatch }, payload) {
    const res = await iAlarm.unReadAlarmOne({ alarmId: payload.alarmId });
    if (!res.code) {
      dispatch("getAlarmCount");
    }
  },

  async setAlarmReadAll({ dispatch }) {
    const res = await iAlarm.readAlarmAll();
    if (!res.code) {
      dispatch("getAlarmCount");
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
